import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'libs/material.module';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';

// Import standalone components
import { AgPaginationToolbarComponent } from 'src/app/shared/ui/ag-pagination-toolbar/ag-pagination-toolbar.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    AgPaginationToolbarComponent,
    MatNativeDateModule
  ],
  exports: [
    MaterialModule,
    AgPaginationToolbarComponent,
    MatNativeDateModule
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' } // or your preferred locale
  ],
})
export class UiModule { }
